// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const rowboat = defineModel({
  id: "rowboat",
  batchId: "future",
  name: "Rowboat",
  tags: ["scenery","rowboat","low-poly","age-of-mcp","future","water"],
  summary: "A small rowboat — ferries people and light cargo across water.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  parts: () => [
      { geometry: new THREE.OctahedronGeometry(0.26, 0), color: "#9a6a3c", position: [0, 0.12, 0], scale: [2.4, 0.6, 1] },
      { geometry: new THREE.ConeGeometry(0.14, 0.34, 6), color: "#9a6a3c", position: [0.58, 0.12, 0], rotation: [0, 0, -1.570796], scale: [1, 1, 0.7] },
      { geometry: new THREE.TorusGeometry(0.27, 0.022, 4, 14), color: "#6f4a26", position: [0, 0.19, 0], rotation: [1.570796, 0, 0], scale: [2.3, 1, 1] },
      { geometry: new THREE.BoxGeometry(0.9, 0.02, 0.24), color: "#6f4a26", position: [0, 0.17, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.03, 0.34), color: "#b08a55", position: [0.16, 0.2, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.03, 0.34), color: "#b08a55", position: [-0.18, 0.2, 0] },
      { geometry: new THREE.CylinderGeometry(0.014, 0.014, 0.7, 5), color: "#c2a878", position: [0, 0.24, 0.16], rotation: [0, 0.35, 0] },
      { geometry: new THREE.BoxGeometry(0.12, 0.015, 0.05), color: "#c2a878", position: [0.33, 0.24, 0.28] },
      { geometry: new THREE.CylinderGeometry(0.014, 0.014, 0.7, 5), color: "#c2a878", position: [0, 0.24, -0.16], rotation: [0, -0.35, 0] },
      { geometry: new THREE.BoxGeometry(0.12, 0.015, 0.05), color: "#c2a878", position: [0.33, 0.24, -0.28] },
    ],
  animations: [],
});
